import axios from "axios";

export interface Creator {
  vanity: string;
  slug: string;
  "avatar-url": string | null;
  "banner-url": string | null;
}

export const getCreator = async (slug: string): Promise<Creator> => {
  return (await axios.get(`/api/v1/creators/${slug}`)).data;
};
